import React from 'react';
import Markdown from 'markdown-to-jsx';
import '../../../styles/features/incidents/IncidentTimeline.css';

const STATUS_LABELS = {
  investigating: 'Investigating',
  identified:    'Identified',
  monitoring:    'Monitoring',
  resolved:      'Resolved',
};

function IncidentTimeline({ updates = [], postMortem }) {
  if (updates.length === 0 && !postMortem) {
    return <p className="timeline-empty">No updates posted yet.</p>;
  }

  // Show newest first
  const sorted = [...updates].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return (
    <div className="incident-timeline">
      {/* Post-mortem block, shown at the top as the final word on the incident */}
      {postMortem && (
        <div className="timeline-postmortem">
          <div className="timeline-postmortem-header">
            <span className="timeline-postmortem-icon">📋</span>
            <span className="timeline-postmortem-label">Post-Mortem</span>
          </div>
          <div className="timeline-postmortem-body">
            <Markdown options={{ disableParsingRawHTML: true }}>{postMortem}</Markdown>
          </div>
        </div>
      )}

      {sorted.map((update, index) => (
        <div key={update.id} className={`timeline-entry ${index === 0 ? 'timeline-latest' : ''}`}>
          <div className="timeline-line">
            <div className="timeline-node" />
            {index < sorted.length - 1 && <div className="timeline-connector" />}
          </div>
          <div className="timeline-content">
            <div className="timeline-meta">
              {update.status_label && (
                <span className={`timeline-status-pill pill-${update.status_label}`}>
                  {STATUS_LABELS[update.status_label] || update.status_label}
                </span>
              )}
              <span className="timeline-time">
                {new Date(update.created_at).toLocaleString(undefined, {
                  month: 'short', day: 'numeric',
                  hour: '2-digit', minute: '2-digit',
                })}
              </span>
              {update.created_by && update.created_by !== 'system' && (
                <span className="timeline-author">- {update.created_by}</span>
              )}
            </div>
            <div className="timeline-body">
              <Markdown options={{ disableParsingRawHTML: true }}>{update.message}</Markdown>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default IncidentTimeline;
